<template>
  <a-modal
    title="公式查看"
    :width="1000"
    :visible="visible"
    @cancel="viewHandleCancel"
    :footer="null">
    <div style="margin-bottom: 20px">
      项目：<a-select
        style="width: 90%"
        placeholder="请选择项目"
        v-model="queryParam.projectId"
        @change="loadDataMy"
        showSearch
        :filterOption="filterOption"
      >
        <a-select-option :value="item.id" v-for="item in projectList">{{item.name}}</a-select-option>
      </a-select>
    </div>
    <a-table :columns='columns'
             :dataSource='dataSource'
             :loading='loading'
             :pagination='ipagination'
             rowKey='id'
             size='small'
             @change='handleTableChange'>
        <span slot='action' slot-scope='text, record'>
          <a-button size='small' type='primary' @click='selectRecord(record)'>选择</a-button>
        </span>
    </a-table>
  </a-modal>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction,postAction } from '@/api/manage'
  export default {
    name: 'AddExist',
    mixins: [JeecgListMixin],
    props:{
      type:{
        type:String,
        default:'1',
      }
    },
    data() {
      return {
        url: {
          list: '/project/projectFormula/list',
        },
        disableMixinCreated: true,
        visible:false,
        projectList:[]
      }
    },
    computed: {
      columns() {
        return [
          {
            title: '排序',
            dataIndex: 'sortNum',
            align: 'center',
            width: 80,
          },
          {
            title: '公式更新表单',
            dataIndex: 'formName',
            width: 300,
            ellipsis: true
          },
          {
            title: '公式更新字段',
            width: 300,
            dataIndex: 'formItemName',
            ellipsis: true
          },
          {
            title: '公式描述',
            dataIndex: 'description',
            ellipsis: true
          },
          // {
          //   title: '状态',
          //   dataIndex: 'status_dictText',
          //   width: 100,
          //   ellipsis: true
          // },
          {
            title: '公式类型',
            width: 100,
            dataIndex: 'type',
            ellipsis: true,
            customRender(text){
              let result = '量表计算'
              if(text==='2'){
                result = '数据填入'
              }else if(text==='3'){
                result = '级联填入'
              }else if(text==='4'){
                result = '周期计算'
              }
              return result
            },
          },
          {
            title: '操作',
            scopedSlots: { customRender: 'action' },
            /*customRender: (text, record) => (
              <span>
                <a-button size='small' type='primary' onClick={event => this.handleStop(record)}>停用</a-button>
                <a-divider type='vertical' />
                <a-button size='small' type='danger' onClick={event => this.handleDelete(record.id)}>删除</a-button>
              </span>)*/
          }
        ]
      }
    },
    created() {
      getAction('/management/project/listAll').then(res=>{
        if(res.success){
          this.projectList = res.result
        }
      })
    },
    methods:{
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      open(){
        this.visible = true
        this.queryParam = {}
        this.dataSource = []
      },
      selectRecord(record){
        this.$emit('handleSelect',record)
      },
      loadDataMy(){
        this.queryParam.type= this.type
        this.loadData()
      },
      viewHandleCancel(){
        this.visible = false
      }
    }
  }
</script>

<style scoped>

</style>